import { Linkable } from '@/components/blocks/Linkable';

interface Props {
	label: string;
	href?: string;
	onClick?: () => void;
}

export const HeaderNavBarSuggest: React.FC<Props> = ({ label, href, onClick }) => (
	<Linkable
		href={href}
		type="inline"
		sx={{
			fontSize: { xs: 'var(--font-size-sm)', md: 'var(--font-size-default)' },
			fontWeight: 'normal',
			color: '#2C2C2C',
			letterSpacing: '0px',
			textDecoration: 'none',
			'&:hover': { textDecoration: 'underline', color: '#2C2C2C' },
			cursor: 'pointer',
		}}
		onClick={onClick}
	>
		{label}
	</Linkable>
);
